import { defineStore } from 'pinia'

export const useViewStore = defineStore('view', {
  state: () => ({
    // Must be a string on first boot; otherwise App.vue renders nothing (white screen)
    actionView: 'registry.dashboard',
	chartsActiveTab: 'comprg',
	username: '',
	currentCustomer: null,
	currentStandort: null,
	openProjects: [],
	allBookings: true,
	activeProjects: true,
	plannedProjects: false,
	resourceFilters: {},
	splitPaneOpen: {},
	splitPaneRatios: {},
	assignmentStandorts: {},
	assignmentScopeMask: null,
	assignmentScopeMaskLoaded: false,
	legalNavResetKey: 0,
	refreshKey: 0,
  }),
  actions: {
	hydrateAssignmentScopeMask(mask) {
		this.assignmentScopeMaskLoaded = true;
		if (mask === null || mask === undefined) {
			this.assignmentScopeMask = 0;
			return;
		}
		const numericMask = Number(mask);
		if (!Number.isInteger(numericMask)) return;
		this.assignmentScopeMask = numericMask;
	},
	setAssignmentScopeMask(mask) {
		const numericMask = Number(mask);
		if (!Number.isInteger(numericMask)) return;
		this.assignmentScopeMask = numericMask;
		this.assignmentScopeMaskLoaded = true;
		this.forceRefresh();
	},
	hasExplicitAssignmentScope() {
		return this.assignmentScopeMask !== null && this.assignmentScopeMask !== undefined;
	},
	assignmentScopeBit(area) {
		const bits = {
			dashboard: 1,
			rechtsgrundlagen: 2,
			pflichten: 4,
			tasks: 8,
		};
		return bits[area] || 0;
	},
	isAssignmentOwn(area) {
		if (!this.hasExplicitAssignmentScope()) return null;
		const bit = this.assignmentScopeBit(area);
		return bit > 0 && (Number(this.assignmentScopeMask) & bit) === bit;
	},
	assignmentScopeMode(area) {
		if (!this.hasExplicitAssignmentScope()) return null;
		return this.isAssignmentOwn(area) ? 'own' : 'all';
	},
	hasExplicitAssignmentScopeFor(area) {
		return this.hasExplicitAssignmentScope() && this.assignmentScopeBit(area) > 0;
	},
	forceRefresh() {
      this.refreshKey++
    },
	markLegalNavReset() {
      this.legalNavResetKey++
    },
    setActionView(view) {
	  console.log("setActionView=" + view)
      this.actionView = view
    },
	setUsername(username) {
	  this.username = username
	},
	setCurrentCustomer(currentCustomer) {
		this.currentCustomer = currentCustomer;
	},
	setCurrentStandort(currentStandort) {
		this.currentStandort = currentStandort;
	},
	setSplitPaneOpen(key, isOpen) {
		if (!key) return;
		this.splitPaneOpen = { ...(this.splitPaneOpen || {}), [key]: !!isOpen };
	},
	getSplitPaneOpen(key) {
		return !!(key && this.splitPaneOpen && this.splitPaneOpen[key]);
	},
	setSplitPaneRatio(key, ratio) {
		if (!key) return;
		const numericRatio = Number(ratio);
		if (!Number.isFinite(numericRatio)) return;
		this.splitPaneRatios = { ...(this.splitPaneRatios || {}), [key]: numericRatio };
	},
	getSplitPaneRatio(key) {
		if (!key || !this.splitPaneRatios || !Object.prototype.hasOwnProperty.call(this.splitPaneRatios, key)) return null;
		const numericRatio = Number(this.splitPaneRatios[key]);
		return Number.isFinite(numericRatio) ? numericRatio : null;
	},
	assignmentStandortKey(rtype, customerId) {
		return `${rtype}:${customerId}`;
	},
	setAssignmentStandort(rtype, customerId, standortId) {
		const key = this.assignmentStandortKey(rtype, customerId);
		this.assignmentStandorts = { ...(this.assignmentStandorts || {}), [key]: standortId };
	},
	getAssignmentStandort(rtype, customerId) {
		const key = this.assignmentStandortKey(rtype, customerId);
		return this.assignmentStandorts && Object.prototype.hasOwnProperty.call(this.assignmentStandorts, key)
			? this.assignmentStandorts[key]
			: null;
	},
	geCurrentCustomer() {
	  return this.currentCustomer;
	},
	getCurrentStandort() {
	  return this.currentStandort;
	},
	isViewDesktop() {
		return this.actionView === 'desktop'
	},
	isViewRegistry() {
		return (this.actionView || '').startsWith('registry');
	},
	setViewDesktop() {
		this.actionView = 'desktop';
	},
	setViewRegistry() {
		this.actionView = 'registry.dashboard';
	},
  },
  persist: true
})
